import React, { useState, useEffect } from 'react';
import { motion, useCycle } from "framer-motion"
import { useDrag } from 'react-dnd';
import './Image.css';
import useSound from 'use-sound';
import open from './../../sounds/open.wav';
import hover from './../../sounds/hover.wav';
import tap from './../../sounds/tap.wav';

const Image = ({ doc, isLoading, isSound, setSelectedImg, x, y }) => {
    var name = doc.id;
    const [openImageSound] = useSound(open, { volume: 0.4 });
    const [hoverImageSound] = useSound(hover, { volume: 0.4 });
    const [tapImageSound] = useSound(tap, { volume: 0.4 });

    const [{ isDragging }, drag] = useDrag(() => ({
        // "type" is required. It is used by the "accept" specification of drop targets.
        type: 'TRASH',
        canDrag: !isLoading,
        item: { name },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult();

            if (item && dropResult) {
                //                setDidDrop(true)
                //alert(`You dropped ${item.name} into ${dropResult.name}!`);
            }
        },
        // The collect function utilizes a "monitor" instance (see the Overview for what this is)
        // to pull important pieces of state from the DnD system.
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            handlerId: monitor.getHandlerId(),
        })
    }))

    const handleClick = () => {
        setSelectedImg(doc);
        isSound && openImageSound();
    }

    return (
        <motion.div className="img-wrap" key={doc.id}
            ref={drag}
            style={{
                fontSize: 25,
                fontWeight: 'bold',
                cursor: 'move',
            }}
            layout
            whileHover={{ opacity: 1, borderColor: "#ffd0ef", scale: 1.1 }}
            whileTap={{ scale: 0.9 }, () => isSound && tapImageSound()}
            onClick={() => handleClick()}
            onMouseEnter={() => isSound && hoverImageSound()}
            animate={{ opacity: 1 }, { x: x, y: y }}
        >
            <motion.img className="image" src={doc.url} alt="Uploaded" loading="lazy" />
        </motion.div>
    )
}

export default Image;